import env from '@config/env';
import { LOG_LEVELS } from '@constants';

class Logger {
  constructor() {
    this.enabled = env.logging.enabled;
    this.level = env.logging.level;
    this.levels = {
      [LOG_LEVELS.DEBUG]: 0,
      [LOG_LEVELS.INFO]: 1,
      [LOG_LEVELS.WARN]: 2,
      [LOG_LEVELS.ERROR]: 3,
    };
  }

  shouldLog(level) {
    if (!this.enabled) return false;
    return this.levels[level] >= this.levels[this.level];
  }

  formatMessage(level, message, data) {
    const timestamp = new Date().toISOString();
    const prefix = `[${timestamp}] [${level.toUpperCase()}]`;
    return { prefix, message, data };
  }

  debug(message, data = null) {
    if (!this.shouldLog(LOG_LEVELS.DEBUG)) return;
    const { prefix } = this.formatMessage(LOG_LEVELS.DEBUG, message, data);
    // console.log(`${prefix} ${message}`, data || '');
  }

  info(message, data = null) {
    if (!this.shouldLog(LOG_LEVELS.INFO)) return;
    const { prefix } = this.formatMessage(LOG_LEVELS.INFO, message, data);
    // console.info(`${prefix} ${message}`, data || '');
  }

  warn(message, data = null) {
    if (!this.shouldLog(LOG_LEVELS.WARN)) return;
    const { prefix } = this.formatMessage(LOG_LEVELS.WARN, message, data);
    console.warn(`${prefix} ${message}`, data || '');
  }

  error(message, error = null) {
    if (!this.shouldLog(LOG_LEVELS.ERROR)) return;
    const { prefix } = this.formatMessage(LOG_LEVELS.ERROR, message, error);
    console.error(`${prefix} ${message}`, error || '');
  }

  group(label) {
    if (!this.enabled) return;
    console.group(label);
  }

  groupEnd() {
    if (!this.enabled) return;
    console.groupEnd();
  }

  table(data) {
    if (!this.enabled) return;
    console.table(data);
  }
}

export const logger = new Logger();
export default logger;
